var app = angular.module('leonardo');

var DynamicFormReactController = function($scope, $q, $window, $rootScope, $document, $state, formObj, ngDialog,
                                          AccountService, DynamicFormRestService, AccountUserService,
                                          NotificationService, FormErrorsService, AuthDataService, AttachmentService,
                                          FolderService, $element, ConfigThemeService) {

  var sectors = AuthDataService.isNotStaff() ? [AccountUserService.currentAccountUser.sector] : formObj.sectors;
  var dynamicFormCopy = angular.copy(formObj);
  dynamicFormCopy.isStaff = AuthDataService.isAdmin();
  dynamicFormCopy.clientInstance = !isNull(dynamicFormCopy.client_instance) ? dynamicFormCopy.client_instance.id : AuthDataService.getClientInstance();
  dynamicFormCopy.sectors = sectors;
  $scope.isEdit = $state.current.action !== 'create';
  $scope.accountPermissions = null;
  $scope.accountUserPermissions = null;
  $scope.availableLanguages = null;
  $scope.preferred_language = null;

  $scope.getPermissions = function (account) {
    var user_account_id = account || ((AccountUserService.currentAccountUser.account && AccountUserService.currentAccountUser.account.id) ?
          AccountUserService.currentAccountUser.account.id : AccountUserService.currentAccountUser.account);
    angular.forEach(AccountUserService.currentAccountUser.permissions, function(permissions) {
      if (permissions.account == user_account_id){
        $scope.accountUserPermissions = permissions;
      }
    });
    angular.forEach(AuthDataService.authData.accountsManager, function(manager) {
      if (manager.id == user_account_id){
        $scope.accountPermissions = manager.permissions;
      }
    });
  }

  $scope.getAvailableLanguages = function (){
    var user_account_id = ((AccountUserService.currentAccountUser.account && AccountUserService.currentAccountUser.account.id) ?
    AccountUserService.currentAccountUser.account.id : AccountUserService.currentAccountUser.account);
    angular.forEach(AuthDataService.authData.accountsManager, function(manager) {
      if (manager.id == user_account_id){
        if(manager.languages){
          $scope.availableLanguages = manager.languages.map(item => {
            return {
              value: item.id,
              label: item.name,
              code: item.code
            };
          });
        }
      }
    });
    if($scope.availableLanguages && $scope.availableLanguages.length > 0){
      $scope.preferred_language = _.cloneDeep(AuthDataService.authData.user.preferred_language);
      if($scope.preferred_language && Object.keys($scope.preferred_language).length > 0){
        $scope.preferred_language.value = $scope.preferred_language.id;
        $scope.preferred_language.label = $scope.preferred_language.name;
        delete $scope.preferred_language.id;
        delete $scope.preferred_language.name;
      }
      else {
        let englishLang = $scope.availableLanguages.filter(lang => lang.code == 'en');
        if(englishLang && englishLang.length > 0){
          $scope.preferred_language = englishLang[0];
        }
        else {
          $scope.preferred_language = $scope.availableLanguages[0];
        }
        
      }
      if($scope.isEdit && dynamicFormCopy.created_in_language){
        let createdInLanguage = $scope.availableLanguages.filter((lang) => { 
          return lang.code == dynamicFormCopy.created_in_language;});
        dynamicFormCopy.created_in_language = createdInLanguage && createdInLanguage.length > 0 ? createdInLanguage[0] : dynamicFormCopy.created_in_language;
        if(dynamicFormCopy.languages && dynamicFormCopy.languages.length > 0){
          dynamicFormCopy.languages = dynamicFormCopy.languages.map(item =>{
            return {
              value: item.id,
              label: item.name,
              code: item.code
            };
          })
        }
      }
      else if($scope.isEdit && !dynamicFormCopy.created_in_language){
        let englishLang = $scope.availableLanguages.filter(lang => lang.code == 'en');
        dynamicFormCopy.created_in_language = englishLang[0];
      }
    }
  }

  $scope.reactSubmissionCallback = function(dynamic_form, stay) {    
    if (!stay) {
      $state.go('documents.dynamic-forms-folder', { pk: $state.params.folder });
    } else {
      if (dynamic_form.id) {
        NotificationService.notify('success', 'Dynamic Form Saved!');
        $state.go('documents.dynamic-forms.edit', { pk: dynamic_form.id }, {reload: true});
        setTimeout(()=>{
          $rootScope.initLayout();
        }, 1000)
      }
      else {
        NotificationService.error('An unexpected error has occurred.');
      }
    }
  };

  $scope.loadReact = function() {
    if (!$element.find('#react-view')[0]) return;
    var el = React.createElement(window.DynamicFormBuilderScreen,
      {
        df: dynamicFormCopy,
        submissionCallback: $scope.reactSubmissionCallback,
        configTheme: {config: ConfigThemeService.config, updated: ConfigThemeService.updated},
        accountPermissions: $scope.accountPermissions,
        accountUserPermissions: $scope.accountUserPermissions,
        userData: {
          isAdmin: AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin(),
        },
        availableLanguages : $scope.availableLanguages, 
        preferredLanguage  : $scope.preferred_language,
        isEdit : $scope.isEdit,
        onAction : $scope.showDiscardDialog
      });
    ReactDOM.render(el, $element.find('#react-view')[0]);
  };

  $scope.showDiscardDialog = function () {
    return ngDialog
      .openConfirm({
        template: 'views/templates/dialog/dynamic-form/discard-form.html',
        controller: 'DiscardFormDialog',
      })
  };

  if (!$scope.isEdit && (AccountService.getCollection().length > 1) && AuthDataService.isNotStaff() &&
    !$state.params.folder) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/account/select.html',
      controller: 'SelectAccountDialog',
      className: 'ngdialog-theme-default ngdialog-select-account',
      data: {
        permission: 'permission_add_dynamic_form',
      },
    }).then(function(account) {
      if (!account) {
        window.history.back();
      }
      dynamicFormCopy.account = (account !== 'all') ? account : null;
      $scope.getAvailableLanguages();
      $scope.getPermissions(dynamicFormCopy.account);
      $scope.loadReact();
    }, function() {
      window.history.back();
    });
  } else {
    if (isNull(dynamicFormCopy.account)) {
      if ($state.params.folder) {
        FolderService.get($state.params.folder).then(function(data) {
          dynamicFormCopy.account = data.account;
        });
      } else {
        dynamicFormCopy.account = (AccountUserService.currentAccountUser.account && AccountUserService.currentAccountUser.account.id) ?
          AccountUserService.currentAccountUser.account.id : AccountUserService.currentAccountUser.account;
      }
    }
    $scope.getAvailableLanguages();
    $scope.getPermissions(dynamicFormCopy.account);
    $scope.loadReact();
  }

  $scope.$on('$destroy', function() {
    if (!$element.find('#react-view')[0]) return;
    ReactDOM.unmountComponentAtNode(document.getElementById('react-view'));
  });

};
app.controller('DynamicFormReactController', [
  '$scope', '$q', '$window', '$rootScope', '$document', '$state', 'formObj', 'ngDialog', 'AccountService',
  'DynamicFormRestService', 'AccountUserService', 'NotificationService', 'FormErrorsService', 'AuthDataService',
  'AttachmentService', 'FolderService', '$element', 'ConfigThemeService', DynamicFormReactController]);
